export default __webpack_public_path__ + "static/media/slide2.6c9dec4f.jpg";